import { render, staticRenderFns } from "./MasterDepartment.vue?vue&type=template&id=257bf07c&"
import script from "./MasterDepartment.vue?vue&type=script&lang=js&"
export * from "./MasterDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports